import { DenseDataGrid, intuitiveFromNow } from '@cibo/ui'
import { Button, Grid, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectAuthLoginDevices } from '../../index'

export const LoginDevices = () => {
  const devices = useSelector(selectAuthLoginDevices)
  const { t } = useTranslation('@cibo/profile/LoginDevices')
  return (
    <Stack spacing={2}>
      <Stack>
        <Typography variant="h6">{t('logInSources')}</Typography>
        <Typography variant="subtitle1">{t('logInSourcesSubtitle')}</Typography>
      </Stack>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Typography variant="body2">{t('logInSourcesDescription')}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}
        >
          <Button variant="outlined" color="error" disabled>
            {t('revoke')}
          </Button>
        </Grid>
      </Grid>
      {devices && (
        <DenseDataGrid
          autoHeight
          rows={devices}
          checkboxSelection
          isRowSelectable={() => false}
          getRowId={p => p.ipAddress}
          columns={[
            {
              field: 'device',
              headerName: t('device'),
              flex: 1,
              valueGetter: ({
                row: {
                  deviceInfo: {
                    browser: { name: browserName, major },
                    os: { name: OSName },
                  },
                },
              }) => `${OSName} - ${browserName} ${major}`,
            },
            {
              field: 'location',
              headerName: t('location'),
              flex: 1,
              valueGetter: ({ row: { geoLocation } }) => geoLocation.join(', '),
            },
            { field: 'ipAddress', flex: 1, headerName: t('ipAddress') },
            {
              field: 'lastLogin',
              flex: 1,
              headerName: t('lastLogin'),
              valueGetter: ({ row: { captureDate } }) => intuitiveFromNow(captureDate),
            },
          ]}
        />
      )}
    </Stack>
  )
}
